import {Component} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {ArianeStore} from "@digicerba/common";

@Component({
  selector: 'home-component',
  templateUrl: './home.component.html',
  host: {'class': 'page'}
})
export class HomePageComponent {

  constructor(private arianeStore: ArianeStore, private translateService: TranslateService) {
    this.initArianne();
  }

  private initArianne() {
    let arianeElements = [
      {
        libelle: "ARIANNE.module",
        route: "/home"
      },
      {
        libelle: "ARIANNE.ACCUEIL.home",
        route: "/home"
      }
    ];

    this.arianeStore.updateElements(arianeElements);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/home/home.component.ts